// @flow
import { createSelector } from 'reselect';
import { clientIdSelector } from './sessionSelector';

export const getVehicleModelsByClient = createSelector(
    [clientIdSelector, state => state.vehicle],
    (clientId, vehicleState) => {
        return vehicleState.getIn([clientId, 'vehicleModels']);
    }
);

export const IsFetchingVehicleModelsInProgress = createSelector(
    [clientIdSelector, state => state.vehicle],
    (clientId, vehicleState) => {
        return vehicleState.getIn([
            clientId,
            'isFetchingVehicleModelsInProgress'
        ]);
    }
);

class VehicleSelectors {
    getDefaultCapacitiesListForPjp = createSelector(
        [getVehicleModelsByClient],
        vehicleModels => {
            return (
                vehicleModels &&
                vehicleModels.map(vehicleModel => {
                    return {
                        label: vehicleModel.name,
                        checked: true,
                        id: vehicleModel.id.modelId,
                        value: vehicleModel.volumeLimit.higherThresh
                    };
                })
            );
        }
    );
    getDefaultDistributionOffset = createSelector(
        [clientIdSelector, state => state.client],
        (clientId, clientState) =>
            clientState.getIn([
                'clientMap',
                clientId,
                'entitySettings',
                'pjpSettings',
                'distributionDelay'
            ])
    );
}
const VehicleSelectorsInstance = new VehicleSelectors();
export { VehicleSelectorsInstance as VehicleSelectors };
